import type {CompRef} from '@wix/document-services-types'
import type {ComponentData} from './types'

type ValidationResult = 'valid' | 'skip_component' | 'skip_section'
export type DataValidatorFn = (data: ComponentData, compPointer: CompRef) => ValidationResult

export class SkipSectionError extends Error {
    constructor(compId: string) {
        super(`Skipping section due to invalid component: ${compId}`)
        this.name = 'SkipSectionError'
    }
}
